import i18next from 'i18next';
import { CUSTOM_TAGS_OPTIONS } from '../Shared/CustomTags';
import permissions from '../../config/permissions';
import { CLAIM_ENTITY_TYPE_SELECTOR_OPTIONS } from '../Claims/constants';
import { INFO_PANE_PAGES } from '../../redux_store/reducer/reducers/infoPaneReducer';
import FILTER_TYPES from '../Shared/Table/widgets/Filters/constants';

export const ALERTS_TYPE = {
  critical: 'Critical',
  nonCritical: 'Non Critical',
  'monitor & support': 'monitor & support',
};

export const ENTITY_SOURCE_TYPE = {
  program: 'Program',
  assessment: 'Assessment',
  resource: 'Resource',
};

export const ALERTS_TYPE_SELECTOR_OPTIONS = [
  {
    label: i18next.t('tables:critical'),
    value: 'critical',
  },
  {
    label: i18next.t('tables:nonCritical'),
    value: 'nonCritical',
  },
  {
    label: i18next.t('tables:monitor&support'),
    value: 'monitor & support',
  },
];

export const STATUS_OPTIONS = [
  {
    label: i18next.t('tables:pendingAcknowledgment'),
    value: 'pendingAcknowledgment',
  },
  {
    label: i18next.t('tables:acknowledged'),
    value: 'acknowledged',
  },
  {
    label: i18next.t('tables:pending'),
    value: 'pending',
  },
];

export const ALERT_CATEGORY_STATUSES = {
  'Imminent Risk': 'Imminent Risk',
  'Help Seeking Behavior': 'Help Seeking Behavior',
  'Risk Factors Identified': 'Risk Factors Identified',
};

export const GET_ALERT_COLUMNS = [
  {
    size: 200,
    header: i18next.t('tables:customTags'),
    accessorKey: 'accountCustomTags',
    permission: permissions.ACCOUNTS_GET,
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
  },
  {
    size: 220,
    header: i18next.t('tables:account'),
    accessorKey: 'accountBusinessName',
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:customId'),
    accessorKey: 'accountCustomIdentifier',
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    filter: {},
    isDefaultCell: true,
  },
  {
    size: 240,
    header: i18next.t('tables:patientFirstName'),
    accessorKey: 'patientFirstName',
    filter: {},
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:patientLastName'),
    accessorKey: 'patientLastName',
    filter: {},
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:patientDOB'),
    accessorKey: 'patientDateOfBirth',
    filter: {
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:mrnNumber'),
    accessorKey: 'patientMrnNumber',
    filter: {},
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 250,
    header: i18next.t('tables:entityNameAlert'),
    accessorKey: 'entityName',
    apiKey: 'alerts',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
      apiKey: 'alerts',
    },
    isDefaultCell: true,
  },
  {
    size: 330,
    header: i18next.t('tables:alertTags'),
    accessorKey: 'alertTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
    },
    cell: {
      withBubbles: true,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:orderDate'),
    accessorKey: 'orderDate',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 230,
    header: i18next.t('tables:appointmentTimestamp'),
    accessorKey: 'appointmentTimestamp',
    filter: {
      shouldRange: true,
      hasNoMaxDate: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 230,
    header: i18next.t('tables:invitedTimestamp'),
    accessorKey: 'invitedTimestamp',
    filter: {
      shouldRange: true,
      hasNoMaxDate: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:viewedTimestamp'),
    accessorKey: 'viewedTimestamp',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 230,
    header: i18next.t('tables:entityType'),
    accessorKey: 'entityType',
    cell: {
      withBubble: true,
    },
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CLAIM_ENTITY_TYPE_SELECTOR_OPTIONS,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:viewedBy'),
    accessorKey: 'viewedBy',
    filter: {},
    isDefaultCell: true,
  },
  {
    size: 250,
    header: i18next.t('tables:alertType'),
    accessorKey: 'alertType',
    cell: {
      withBubble: true,
    },
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: ALERTS_TYPE_SELECTOR_OPTIONS,
    },
  },
  {
    size: 260,
    header: i18next.t('tables:acknowledgeStatus'),
    accessorKey: 'acknowledgeStatus',
    cell: {
      withBubble: true,
    },
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: STATUS_OPTIONS,
    },
  },
  {
    size: 250,
    header: i18next.t('tables:acknowledgedBy'),
    accessorKey: 'acknowledgedBy',
    filter: {},
    isDefaultCell: true,
  },
  {
    size: 250,
    header: i18next.t('tables:acknowledgedTimestamp'),
    accessorKey: 'acknowledgedTimestamp',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 250,
    header: i18next.t('tables:createdTimestamp'),
    accessorKey: 'createdTimestamp',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
];
